import storage from 'services/storage';

export const types = {
  SET_DATA_ENRICHMENT_FILTERS: 'SET_DATA_ENRICHMENT_FILTERS',
  RESTORE_STATE: 'RESTORE_DATA_ENRICHMENT_STATE',
  SET_DATA_ENRICHMENT_DATE_OPTION: 'SET_DATA_ENRICHMENT_DATE_OPTION',
  SIGNAL_R_ENRICHMENT_UPDATE: 'SIGNAL_R_ENRICHMENT_UPDATE',
};

const persistState = async getState => {
  const state = getState();
  const toSave = JSON.parse(JSON.stringify(state)).dataEnrichment;
  await storage.setItem('dataEnrichment', toSave);
};

export const setFilters = (userId, value) => (dispatch, getState) => {
  dispatch({
    type: types.SET_DATA_ENRICHMENT_FILTERS,
    payload: { userId, value },
  });
  persistState(getState);
};

export const setDateOption = (userId, option) => (dispatch, getState) => {
  dispatch({
    type: types.SET_DATA_ENRICHMENT_DATE_OPTION,
    payload: { userId, option },
  });
  persistState(getState);
};

export const signalREnrichmentUpdate = dataEnrichmentId => dispatch => {
  dispatch({
    type: types.SIGNAL_R_ENRICHMENT_UPDATE,
    payload: dataEnrichmentId,
  });
};

export const restoreState = state => ({
  type: types.RESTORE_STATE,
  payload: state,
});
